import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase';
import { useLanguage } from '../../contexts/LanguageContext';
import { deduplicateRecurring } from '../../utils/deduplicateRecurring';
import { upcomingQueryStart, isOngoingOrUpcoming, getPanelDateFields } from '../../utils/eventDates';
import EventDateTime from '../EventDateTime';
import NewsletterLink from '../NewsletterLink';
import '../EventPanels.css'; // Import EventPanels styles for consistency
import '../../App.css';

function EventsPage() {
  const { language } = useLanguage();
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const startOfToday = new Date();
    startOfToday.setHours(0, 0, 0, 0);

    // Query window is widened so multi-day events already underway are still
    // fetched; isOngoingOrUpcoming filters out genuinely past events.
    const eventsQuery = query(
      collection(db, 'events'),
      where('date', '>=', upcomingQueryStart(startOfToday)),
      orderBy('date', 'asc')
    );

    const unsubscribe = onSnapshot(eventsQuery, (snapshot) => {
      const eventsList = snapshot.docs
        .filter(doc => isOngoingOrUpcoming(doc.data(), startOfToday))
        .map(doc => {
        const data = doc.data();
        const eventDate = data.date && data.date.toDate ? data.date.toDate() : new Date(data.date);
        return {
          id: doc.id,
          image: (data.thumbnailUrl || data.imageUrl) || '/images/studio.png',
          title: (language === 'sv' && data.title_sv) || data.title,
          subtitle: (language === 'sv' && data.subtitle_sv) || data.subtitle || '',
          date: eventDate,
          type: data.type,
          price: data.price || 250,
          memberPrice: data.memberPrice || 200,
          ...getPanelDateFields(data.date, data.endDate, language === 'sv' ? 'sv-SE' : 'en-GB'),
          recurringGroupId: data.recurringGroupId || null
        };
      });

      setEvents(deduplicateRecurring(eventsList));
    });

    return () => unsubscribe();
  }, [language]);

  return (
    <div className="event-panels events-page-layout">
      <NewsletterLink padding="25px 20px 4px" />
      <div className="panels-container">
        {events.map((event, index) => (
          <div 
            key={event.id}
            className={`event-panel ${index === 0 ? 'static-panel' : ''}`}
          >
            {index === 0 && (
              <div className="panel-header">
                <h2> </h2>
              </div>
            )}
            {index === 1 && (
              <div className="panel-header">
                <h2> </h2>
              </div>
            )}
            {index > 1 && (
              <div className="panel-header">
                <h2> </h2>
              </div>
            )}
            <div className="panel-content">
              <Link to={`/event/${event.id}`} className="event-link">
                <div 
                  className="event-image-container"
                  style={{
                    backgroundImage: `url(${event.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                  }}
                />
                <div className="event-info">
                  <div className="event-datetime">
                    <EventDateTime event={event} />
                  </div>
                  <h3>{event.title}</h3>
                  <p>{event.subtitle}</p>
                </div>
              </Link>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
}

export default EventsPage;
